import { Button, Tag, message } from "antd";
import _ from "lodash";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom/dist";
import courseService from "services/course.services";
import RatingStar from "./RatingStar";
import { getRoleUser } from "utils";
import numeral from "numeral";
import { NO_IMAGE } from "assets/images";
import { errorToMessage } from "hooks/functions/errorToMessage";
import { AlertError } from "./alert/Alert";
import { TOGGLE_TO_LOAD } from "redux/reducers/cartSlice";
import masterService from "services/master.services";
import { useEffect, useState } from "react";
import { ROLE_USER } from "constants/roleUserConstant";

const PackageCard = ({ data }) => {
  const courseId = data?.id;
  const roleUser = getRoleUser();
  const toMyCoursePath = `/${roleUser}/course/${courseId}`;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const myCart = useSelector((state) => state.cart);
  const [messageApi, contextHolder] = message.useMessage();
  const [isPurcharse, setIsPurcharse] = useState(false)

  const warning = () => {
    messageApi.open({
      type: "warning",
      content: "มีรายการนี้แล้ว !",
    });
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "เพิ่มรายการลงตะกร้าเรียบร้อย !",
    });
  };
  const { data: getAllMyCourseId } = masterService.useQueryGetAllMyPurchase({});
  const { mutate: addToCart } = courseService.useMutationAddItemToCart(
    () => {
      success();
      dispatch(TOGGLE_TO_LOAD());
    },
    (err) => {
      const statusCode = err?.response?.status;
      const isForbidden = statusCode == 403;
      if (isForbidden) {
        navigate("/login");
      } else if (err?.response?.data?.status?.description !== "ข้อมูลซ้ำกับในระบบ") {
        AlertError({ text: errorToMessage(err) });
      }
    }
  );

  const handleAddToCart = () => {
    let isDuplicate = _.find(myCart?.items, (n) => n.courseId === data?.id);
    if (isDuplicate) {
      warning();
    } else {
      addToCart({ courseId: data?.id });
    }
  };

  const HREF_COURSE = isPurcharse ? toMyCoursePath : `/packages/${data?.id}`;

  useEffect(() => {
    if (getAllMyCourseId?.data) {
      setIsPurcharse(getAllMyCourseId.data.some(e => e.packageId === courseId))
    } else {
      setIsPurcharse(false)
    }
  }, [getAllMyCourseId])

  return (
    <div className="sa-course">
      {contextHolder}
      <span className="badges">
        {data?.delPrice > 0 && <del>{`THB ${data?.delPrice || 0}`}</del>}{" "}
        {`THB ${data?.price || 0}`}
      </span>
      <div className="course-thumb">
        <div style={{ height: "260px" }} className="center">
          <img
            style={{ objectFit: "cover", height: "100%", width: "100%" }}
            src={data?.coverImgUrl || NO_IMAGE}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = NO_IMAGE;
            }}
            alt="cover-package"
            className="img-fluid"
          />
        </div>
        <div className="overlay">
          <div className="icons">
            {
              !roleUser || roleUser == ROLE_USER.student ?
                <ul className="global-list">
                  {!isPurcharse ? (
                    <>
                      <li>
                        <Link to={`/courses/${data?.id}`}>
                          <i className="fas fa-link"></i>
                        </Link>
                      </li>
                      {
                        !data?.isGroup ?
                          <li>
                            <a
                              href="#"
                              style={{ cursor: "pointer" }}
                              onClick={handleAddToCart}
                            >
                              <i className="fas fa-cart-plus"></i>
                            </a>
                          </li>
                          :
                          <></>
                      }

                    </>
                  ) : null}
                </ul>
                : null
            }
          </div>
        </div>
        <div className="rating-date align-self-end">
          <ul className="global-list d-flex star-rating align-self-center">
            <RatingStar rating={data?.rating || 0} />
          </ul>
          <div className="date">
            <span>
              <i className="far fa-clock"></i>
              {moment(data?.date).format("DD MMM YYYY")}
            </span>
          </div>
        </div>
      </div>

      <div className="course-info">
        <div className="info">
          <h2 style={{ minHeight: "40px" }} className="title">
            <Link to={HREF_COURSE}>{data?.title || "-"}</Link>
          </h2>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <p className="m-0">{`รวม ${_.size(
              data?.packageDetail
            )} บทเรียน`}</p>
            <Tag color="green">แพ็กเกจ</Tag>
          </div>
        </div>
        <div>
          <ul
            className="global-list w-100"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <li>
              <a
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    marginRight: "8px",
                    width: "32px",
                    height: "32px",
                    borderRadius: "100px",
                    backgroundColor: "grey",
                    overflow: "hidden",
                  }}
                  className="center"
                >
                  <img
                    src={data?.teacherImg || NO_IMAGE}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = NO_IMAGE;
                    }}
                    alt="profile"
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                {data?.teacherName || "Teacher Name"}
              </a>
            </li>
          </ul>
        </div>
        <div className="sa-meta">
          <ul
            className="global-list"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <li>
              <a href="#" className="center">
                <p style={{ margin: "0px" }} className="text-primary">
                  {numeral(data?.price).format("0,0")} บาท
                </p>
                {
                  data?.delPrice ? (
                    <del
                      style={{
                        marginLeft: "8px",
                        fontWeight: "lighter",
                        fontSize: "14px",
                      }}
                    >
                      {numeral(data?.delPrice).format("0,0")}.-
                    </del>
                  )
                    :
                    null
                }
              </a>
            </li>
            {_.includes(getAllMyCourseId?.data, courseId) ? (
              <li>
                <a href={toMyCoursePath} target="_blank">
                  <Button type="primary">ไปยังแพ็กเกจ</Button>
                </a>
              </li>
            ) : !roleUser || roleUser == ROLE_USER.student ? (
              <li>
                <a
                  href="#"
                  style={{ cursor: "pointer" }}
                  onClick={handleAddToCart}
                >
                  <i className="fa fa-shopping-cart" />
                </a>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
